import { render } from "./MrpItem.vue?vue&type=template&id=06bd7461&scoped=true"
import script from "./MrpItem.vue?vue&type=script&lang=js"
export * from "./MrpItem.vue?vue&type=script&lang=js"

import "./MrpItem.vue?vue&type=style&index=0&id=06bd7461&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06bd7461"]])

export default __exports__